<template>
  <div v-loading="loading" class="vocabulary-homework">
    <div
      class="md-layout-item md-small-size-100 md-xsmall-size-100"
      style="height: 60px"
      :style="$isMobileDevice ? 'margin-bottom: 40px' : ''"
    >
      <div
        class="md-layout w-100 header"
        style="color: #1cab36; margin: 0px 15px 10px 0px"
      >
        <div class="left-hw-btn">
          <md-button
            @click="goBack"
            class="md-icon-button"
            style="height: 58px; width: 58px; margin-right: 20px"
          >
            <md-icon
              style="
                font-size: 36px !important;
                color: #1cab36;
                line-height: 58px;
              "
              >arrow_back</md-icon
            >
          </md-button>

          <div v-if="homework" class="homework-title">
            {{ homework.name }}
          </div>
        </div>

        <div class="right-hw-btn" v-if="!examVaultId && !$route.params.examVaultId">
          <span
            style="margin-right: 10px"
            v-if="homework"
            class="homework-edit"
            @click="handleUpdateHomework"
          >
            <md-icon>edit</md-icon>
            <span class="label">Cập nhật</span>
          </span>
          <span
            v-if="homework"
            class="homework-edit"
            @click="handlePublishHomework"
          >
            <md-icon>public</md-icon>
            <span class="label">{{
              homework.publish ? 'Huỷ phát hành' : 'Phát hành'
            }}</span>
          </span>
        </div>
      </div>
    </div>

    <div v-if="homework" class="question-layout md-layout">
      <div
        class="md-layout-item md-size-25 md-small-size-100 question-group-list"
        :style="$isMobileDevice ? 'margin-bottom: 24px;' : ''"
      >
        <div class="sidebar-header">
          <span class="sidebar-title"><md-icon style="color: #1cab36; margin-right: 6px;">record_voice_over</md-icon> Các lượt thoại</span>
          <el-tag size="mini" type="success">{{ conversations.length }} lượt</el-tag>
        </div>

        <div class="question-groups">
          <div
            v-for="(conv, index) in conversations"
            :key="conv._id || index"
            class="q-item"
            :class="
              currentConversation && conv._id === currentConversation._id
                ? 'q-item-selected'
                : ''
            "
            @click="handleSelectConversation(conv)"
          >
            <div class="q-item-left">
              <span class="conv-user-badge" :class="conv.user === 'A' ? 'user-a' : 'user-b'">
                {{ conv.user || '?' }}
              </span>
              <div class="conv-info">
                <span class="title">
                  {{ conv[conv.user] && conv[conv.user].length > 0 ? conv[conv.user][0][0] : 'Câu thoại mới' }}
                </span>
                <span class="sub-text">Thứ tự: #{{ conv.index || index + 1 }}</span>
              </div>
            </div>

            <div class="settings">
              <span class="action-btn" @click.stop="handleUpdateConversation('update', conv)">
                <md-icon>edit</md-icon>
              </span>
              <span class="action-btn delete-btn" @click.stop="handleDeleteConversation(conv)">
                <md-icon>delete</md-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="add-question-group-btn">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="handleUpdateConversation('create')">
            Thêm lượt thoại
          </el-button>
        </div>
      </div>

      <div class="md-layout-item md-size-75 preview-section">
        <div v-if="conversations.length > 0" class="full-conversation-preview">
          <div class="preview-header-bar">
            <h3 class="preview-title"><md-icon style="color: #1cab36;">forum</md-icon> Kịch bản hội thoại đối thoại</h3>
          </div>

          <div class="chat-viewport">
            <div v-for="(conv, idx) in conversations" :key="'prev-'+idx" class="chat-row" :class="conv.user === 'A' ? 'row-left' : 'row-right'">
              <!-- Avatar nhân vật A -->
              <div v-if="conv.user === 'A'" class="avatar-circle avatar-a">
                <md-icon>person</md-icon>
              </div>

              <!-- Nội dung tin nhắn chat -->
              <div class="chat-bubble-container">
                <div class="speaker-label" :class="conv.user === 'A' ? 'label-a' : 'label-b'">
                  Nhân vật {{ conv.user }}
                </div>
                <div v-for="(line, lIdx) in conv[conv.user]" :key="'line-'+lIdx" class="chat-bubble" :class="conv.user === 'A' ? 'bubble-a' : 'bubble-b'">
                  <div class="bubble-text">{{ line[0] }}</div>
                  <div v-if="line[3]" class="bubble-ipa" style="color: #606266; font-style: italic; font-size: 13px; margin-bottom: 4px;">/{{ line[3] }}/</div>
                  <div v-if="line[1]" class="bubble-mean">{{ line[1] }}</div>
                  <div v-if="line[2]" class="bubble-audio">
                     <audio controls :src="line[2]" class="chat-audio-player"></audio>
                  </div>
                </div>
              </div>

              <!-- Avatar nhân vật B -->
              <div v-if="conv.user === 'B'" class="avatar-circle avatar-b">
                <md-icon>person_outline</md-icon>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <md-icon style="font-size: 48px; color: #ccc;">forum</md-icon>
          <p>Chưa có nội dung hội thoại. Nhấp vào nút Thêm lượt thoại để bắt đầu.</p>
        </div>
      </div>
    </div>

    <md-dialog
      :md-active.sync="conversationDialog.visible"
      :md-fullscreen="false"
      class="question-group-dialog custom-conv-dialog"
    >
      <md-dialog-title>
        <div class="dialog-header-bar">
          <span class="dialog-title-text"><md-icon style="color: #1cab36;">edit</md-icon> {{ conversationDialog.method === 'create' ? 'Thêm lượt thoại mới' : 'Chỉnh sửa lượt thoại' }}</span>
          <BaseButton :label="$t('SAVE')" @click="saveConversation" />
        </div>
      </md-dialog-title>

      <md-dialog-content>
        <div class="dialog-form-container">
          <div class="role-selector-bar">
            <span class="selector-label">Nhân vật đóng vai nói chính:</span>
            <el-radio-group v-model="temp.user" size="medium">
              <el-radio-button label="A"><md-icon>person</md-icon> Nhân vật A</el-radio-button>
              <el-radio-button label="B"><md-icon>person_outline</md-icon> Nhân vật B</el-radio-button>
            </el-radio-group>
          </div>

          <div class="order-input-bar">
            <span class="selector-label">Thứ tự lượt thoại:</span>
            <el-input-number v-model="temp.index" :min="1" size="small"></el-input-number>
          </div>

          <el-row :gutter="20">
            <!-- Form thoại nhân vật A -->
            <el-col :span="12">
              <div class="role-card role-card-a">
                <div class="role-card-header">
                  <span class="role-title title-a"><md-icon>person</md-icon> Nhân vật A</span>
                  <el-button type="success" size="mini" icon="el-icon-plus" @click="addLine('A')">Thêm dòng</el-button>
                </div>

                <div v-for="(line, idx) in temp.A" :key="'A'+idx" class="line-item-card">
                  <el-button v-if="temp.A.length > 1" circle type="danger" icon="el-icon-close" size="mini" class="delete-line-btn" @click="removeLine('A', idx)"></el-button>

                  <el-form label-position="top" size="small">
                    <el-form-item :label="'Dòng ' + (idx + 1) + ' - Câu'">
                      <el-input v-model="line[0]" placeholder="Nhập câu..."></el-input>
                    </el-form-item>
                    <el-form-item label="Phiên âm (IPA)">
                      <el-input v-model="line[3]" placeholder="Nhập phiên âm..."></el-input>
                    </el-form-item>
                    <el-form-item label="Dịch nghĩa tiếng Việt">
                      <el-input v-model="line[1]" placeholder="Nhập dịch nghĩa..."></el-input>
                    </el-form-item>
                    <BaseInputQuestionFile
                      :label="'Âm thanh phát âm (Audio)'"
                      accept="audio/*"
                      :labelSize="14"
                      :loading.sync="uploadLoading['audioA'+idx]"
                      v-model="line[2]"
                      iconClass="audiotrack"
                      :storageClass="config.storageClass"

                      @file-selected="(val) => { handleUpload(line, 2, 'audioA' + idx, val) }"
                      @clear="clearFile(line, 2)"
                    />
                  </el-form>
                </div>
              </div>
            </el-col>

            <!-- Form thoại nhân vật B -->
            <el-col :span="12">
              <div class="role-card role-card-b">
                <div class="role-card-header">
                  <span class="role-title title-b"><md-icon>person_outline</md-icon> Nhân vật B</span>
                  <el-button type="warning" size="mini" icon="el-icon-plus" @click="addLine('B')">Thêm dòng</el-button>
                </div>

                <div v-for="(line, idx) in temp.B" :key="'B'+idx" class="line-item-card">
                  <el-button v-if="temp.B.length > 1" circle type="danger" icon="el-icon-close" size="mini" class="delete-line-btn" @click="removeLine('B', idx)"></el-button>

                  <el-form label-position="top" size="small">
                    <el-form-item :label="'Dòng ' + (idx + 1) + ' - Câu'">
                      <el-input v-model="line[0]" placeholder="Nhập câu..."></el-input>
                    </el-form-item>
                    <el-form-item label="Phiên âm (IPA)">
                      <el-input v-model="line[3]" placeholder="Nhập phiên âm..."></el-input>
                    </el-form-item>
                    <el-form-item label="Dịch nghĩa tiếng Việt">
                      <el-input v-model="line[1]" placeholder="Nhập dịch nghĩa..."></el-input>
                    </el-form-item>
                    <BaseInputQuestionFile
                      :label="'Âm thanh phát âm (Audio)'"
                      accept="audio/*"
                      :labelSize="14"
                      :loading.sync="uploadLoading['audioB'+idx]"
                      v-model="line[2]"
                      iconClass="audiotrack"
                      :storageClass="config.storageClass"

                      @file-selected="(val) => { handleUpload(line, 2, 'audioB' + idx, val) }"
                      @clear="clearFile(line, 2)"
                    />
                  </el-form>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      :md-active.sync="updateHomeworkDialog"
      class="update-homework-dialog"
      @md-clicked-outside="updateHomeworkDialog = false"
    >
      <md-dialog-title>
        <div class="title">
          {{ $t('UPDATE') }}
        </div>
      </md-dialog-title>
      <md-dialog-content v-loading="dialogLoading">
        <div class="input-field">
          <BaseInputText
            :placeholder="$t('NAME')"
            :label="$t('NAME')"
            v-model="homeworkTemp.name"
          />
        </div>
        <div class="input-field">
          <label class="label">{{ $t('HW_VIDEO_SUBJECT') }}</label>
          <BaseInputSelectV2
            v-if="examVaultConfig && examVaultConfig.subjects"
            :options="mappedSubjects"
            :opt-key="'mappedId'"
            :opt-value="`${$i18n.locale}Value`"
            v-model="homeworkTemp.subject"
          />
        </div>
        <div class="input-field">
          <BaseInputSelect
            :multiple="true"
            :options="getStudents()"
            opt-value="fullname"
            :placeholder="$t('ASSIGNEES')"
            :label="$t('ASSIGNEES')"
            v-model="homeworkTemp.assignedEIDs"
            :value="homeworkTemp.assignedEIDs"
            @update="handleChangeAssignStudent"
          />
        </div>
        <div class="input-field">
          <BaseDatePicker
            :placeholder="$t('EXER_ASSIGN_DATE')"
            :label="$t('EXER_ASSIGN_DATE')"
            v-model="homeworkTemp.startAt"
          />
        </div>
        <div class="input-field">
          <BaseDatePicker
            :placeholder="$t('EXER_DEADLINE_DATE')"
            :label="$t('EXER_DEADLINE_DATE')"
            v-model="homeworkTemp.endAt"
          />
        </div>
        <BaseInputText
          :placeholder="$t('EXER_TRY_TIMES')"
          :label="$t('EXER_TRY_TIMES')"
          :labelSize="18"
          :max="100"
          type="number"
          v-model="homeworkTemp.limitSubmit"
        />
        <div class="input-field" style="padding-top: 20px">
          <BaseCheckbox :label="$t('SHOW_ANSWER_KEY')" v-model="homeworkTemp.showAnswerKey" />
        </div>
        <div class="btn-block" style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
          <md-button class="md-raised" @click.prevent="updateHomeworkDialog = false">
            {{ $t('CANCEL') }}
          </md-button>
          <md-button
            class="md-raised md-primary text-white"
            @click.prevent="saveHomeworkSettings"
          >
            {{ $t('UPDATE') }}
          </md-button>
        </div>
      </md-dialog-content>
    </md-dialog>

    <el-dialog
      :visible.sync="examVaultDialog.visible"
      @close="examVaultDialog.visible = false"
      title="Kho học liệu"
      width="85%"
      append-to-body
    >
      <ExamVaultView @selectExam="handleSelectExam" />
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { uploadHomeworkAttachment } from '@/api/content'
import { mapGetters } from 'vuex'
import ExamVaultView from '@/views/ExamVault/components/ExamVaultView.vue'
import examVaultApi from '@/api/exam-vault'

function generateObjectId() {
  const timestamp = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0')
  const randomHex = Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join('')
  return timestamp + randomHex
}

export default {
  name: 'ClassConversationHomework',
  props: {
    examVaultId: {
      type: String,
      default: null
    },
    initialExam: {
      type: Object,
      default: null
    }
  },
  components: {
    ExamVaultView
  },
  data() {
    return {
      classUid: null,
      homeworkUid: null,
      homework: null,
      conversations: [],
      currentConversation: null,
      loading: false,
      conversationDialog: {
        visible: false,
        method: 'create'
      },
      updateHomeworkDialog: false,
      dialogLoading: false,
      homeworkTemp: {},
      examVaultDialog: {
        visible: false
      },
      temp: { _id: null, index: 1, A: [['', '', '', '']],
        B: [['', '', '', '']],
        user: 'A'
      },
      uploadLoading: {
        audioA: false,
        audioB: false
      },
      config: {
        storageClass: 'STANDARD'
      }
    }
  },
  computed: {
    ...mapGetters({
      eClass: 'eClass',
      students: 'students'
    }),
    examVaultConfig() {
      return this.$store.state['exam-vault'].config
    },
    mappedSubjects() {
      if (!this.examVaultConfig || !this.examVaultConfig.subjects) return []
      return this.examVaultConfig.subjects.map(s => ({
        ...s,
        mappedId: this.getMappedSubject(s._id)
      }))
    }
  },
  async created() {
    this.classUid = this.$route.params.classUid
    this.homeworkUid = this.$route.query.homeworkUid
    const targetExamVaultId = this.examVaultId || this.$route.params.examVaultId
    if (targetExamVaultId) {
      await this.fetchExamVaultData(targetExamVaultId)
    } else {
      if (!this.examVaultConfig || !this.examVaultConfig.subjects || this.examVaultConfig.subjects.length === 0) {
        this.$store.dispatch('exam-vault/fetchExamConfig')
      }
      await this.fetchData()
    }
  },
  methods: {
    async handleUpload(line, indexInLine, loadingKey, files) {
      if (files.length > 0) {
        await this.uploadAttachment(files[0], line, indexInLine, loadingKey)
      }
    },
    async uploadAttachment(file, line, indexInLine, loadingKey) {
      if (this.uploadLoading[loadingKey]) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng đợi tải lên các tập tin trước đó hoàn tất.'
        })
        return
      }

      this.$set(this.uploadLoading, loadingKey, true)
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        let response
        if (targetId) {
          response = await examVaultApi.uploadAttachment({
            file,
            examVaultId: targetId
          })
        } else {
          const classId = this.classUid || (this.homework && this.homework.classId)
          response = await uploadHomeworkAttachment({
            file,
            classId: classId
          })
        }
        if (response.data && response.data.key) {
          this.$set(line, indexInLine, '/' + response.data.key)
        } else {
          this.$message.error('Tải lên thất bại')
        }
      } catch (e) {
        this.$message.error('Lỗi khi tải lên file')
      } finally {
        this.$set(this.uploadLoading, loadingKey, false)
      }
    },
    clearFile(line, indexInLine) {
      this.$set(line, indexInLine, '')
    },
    async fetchExamVaultData(id) {
      this.loading = true
      try {
        let examData = this.initialExam
        if (!examData || !examData._id) {
          const res = await examVaultApi.getExamById(id)
          examData = res.data || res
        }
        this.homework = {
          _id: examData._id,
          name: examData.title,
          title: examData.title,
          subject: examData.subject ? (examData.subject.value || examData.subject) : '',
          ...examData
        }
        const rawConvs = examData.conversations || []
        this.conversations = rawConvs.map((c, i) => ({
          ...c,
          _id: c._id || c.id || generateObjectId(),
          index: c.index || i + 1
        }))
        this.conversations.forEach(c => {
          if (!c.A || !Array.isArray(c.A)) c.A = [['', '', '', '']]
          else if (c.A.length > 0 && typeof c.A[0] === 'string') c.A = [c.A]
          c.A = c.A.map(line => {
            if (!Array.isArray(line)) return ['', '', '', '']
            if (line.length === 3) return [line[0], line[1], line[2], '']
            if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
            if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
            return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
          })

          if (!c.B || !Array.isArray(c.B)) c.B = [['', '', '', '']]
          else if (c.B.length > 0 && typeof c.B[0] === 'string') c.B = [c.B]
          c.B = c.B.map(line => {
            if (!Array.isArray(line)) return ['', '', '', '']
            if (line.length === 3) return [line[0], line[1], line[2], '']
            if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
            if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
            return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
          })
        })
        if (this.conversations.length > 0) {
          this.currentConversation = this.conversations[0]
        }
      } catch (err) {
        this.$message.error('Lỗi khi tải dữ liệu câu thoại kho học liệu')
      } finally {
        this.loading = false
      }
    },
    async fetchData() {
      this.loading = true
      try {
        if (this.classUid) {
          await this.$store.dispatch('content/getClass', {
            classUid: this.classUid
          })
        }
        const homework = await this.$store.dispatch('content/getHomework', {
          classId: this.classUid,
          homeworkUid: this.homeworkUid
        })
        this.homework = _.cloneDeep(homework)
        const rawConvs = this.homework.conversations || []
        this.conversations = rawConvs.map((c, i) => ({
          ...c,
          _id: c._id || c.id || generateObjectId(),
          index: c.index || i + 1
        }))

        // Đảm bảo cấu trúc mảng A và B là 2D và có 3 phần tử [câu, nghĩa, audio]
        this.conversations.forEach(c => {
          if (!c.A || !Array.isArray(c.A)) c.A = [['', '', '', '']]
          else if (c.A.length > 0 && typeof c.A[0] === 'string') c.A = [c.A]
          c.A = c.A.map(line => {
            if (!Array.isArray(line)) return ['', '', '', '']
            if (line.length === 3) return [line[0], line[1], line[2], '']
            if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
            if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
            return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
          })

          if (!c.B || !Array.isArray(c.B)) c.B = [['', '', '', '']]
          else if (c.B.length > 0 && typeof c.B[0] === 'string') c.B = [c.B]
          c.B = c.B.map(line => {
            if (!Array.isArray(line)) return ['', '', '', '']
            if (line.length === 3) return [line[0], line[1], line[2], '']
            if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
            if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
            return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
          })
        })

        if (this.conversations.length > 0) {
          this.currentConversation = this.conversations[0]
        }
      } catch (err) {
        this.$message.error('Lỗi khi tải dữ liệu bài tập')
      } finally {
        this.loading = false
      }
    },
    getStudents() {
      return (this.students || [])
        .filter((d) => !_.isNil(d.eID) && d.status === 'approved')
        .map((d) => ({ ...d, _id: d.eID }))
    },
    handleChangeAssignStudent() {
      if (this.homework && this.homework.isLocked && this.homework.assignedEIDs) {
        const currentIds = this.homeworkTemp.assignedEIDs || []
        const originalIds = this.homework.assignedEIDs || []
        const missingIds = originalIds.filter((id) => !currentIds.includes(id))
        if (missingIds.length > 0) {
          this.$set(this.homeworkTemp, 'assignedEIDs', [
            ...currentIds,
            ...missingIds
          ])
          this.$notify({
            type: 'warning',
            title: 'Warning',
            message: 'Không thể bỏ học sinh đã được giao bài tập.'
          })
        }
      }
      this.$set(
        this.homeworkTemp,
        'assignAll',
        this.homeworkTemp.assignedEIDs ? this.homeworkTemp.assignedEIDs.length === this.getStudents().length : false
      )
    },
    getMappedSubject(subjectId) {
      if (!subjectId) return null
      const subjectMap = {
        english: 'en',
        math: 'math',
        vietnamese: 'vi',
        chemistry: 'chem',
        chinese: 'zh',
        vi: 'vi',
        en: 'en'
      }
      if (this.examVaultConfig && this.examVaultConfig.subjects) {
        const found = this.examVaultConfig.subjects.find(s => s._id === subjectId)
        if (found && found.value) {
          const valLower = found.value.toLowerCase()
          return subjectMap[valLower] || valLower.substring(0, 2)
        }
      }
      const idLower = subjectId.toLowerCase()
      return subjectMap[idLower] || idLower.substring(0, 2)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          path: '/kho-hoc-lieu',
          query: this.$route.query
        })
      }
    },
    handleSelectConversation(conv) {
      this.currentConversation = conv
    },
    handleUpdateConversation(method, conv) {
      this.conversationDialog.method = method
      if (method === 'create') {
        let defaultUser = 'A'
        if (this.conversations.length > 0) {
          const lastConv = this.conversations[this.conversations.length - 1]
          defaultUser = lastConv.user === 'A' ? 'B' : 'A'
        }

        this.temp = { _id: generateObjectId(), index: this.conversations.length + 1, A: [['', '', '', '']], B: [['', '', '', '']], user: defaultUser }
      } else {
        const cloned = _.cloneDeep(conv)
        if (!cloned._id) {
          cloned._id = conv.id || generateObjectId()
        }
        if (cloned.A && cloned.A.length > 0 && typeof cloned.A[0] === 'string') cloned.A = [cloned.A]
        cloned.A = cloned.A.map(line => {
          if (!Array.isArray(line)) return ['', '', '', '']
          if (line.length === 3) return [line[0], line[1], line[2], '']
          if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
          if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
          return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
        })
        cloned.B = cloned.B.map(line => {
          if (!Array.isArray(line)) return ['', '', '', '']
          if (line.length === 3) return [line[0], line[1], line[2], '']
          if (line.length === 4 && line[0] !== 'A' && line[0] !== 'B') return [line[0], line[1], line[2], line[3] || '']
          if (line.length === 4) return [line[1] || '', line[2] || '', line[3] || '', '']
          return [line[0] || '', line[1] || '', line[2] || '', line[3] || '']
        })
        this.temp = cloned
      }
      this.conversationDialog.visible = true
    },
    async saveConversationsToBackend() {
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        if (targetId) {
          const payload = {
            ...this.homework,
            conversations: this.conversations
          }
          if (payload.subject && payload.subject._id) payload.subject = payload.subject._id
          if (payload.productType && payload.productType._id) payload.productType = payload.productType._id
          if (payload.categoryIds) {
            payload.categoryIds = payload.categoryIds.map(c => c._id || c)
          }
          await examVaultApi.updateExam(payload)
        } else {
          const payload = {
            ...this.homework,
            classId: this.classUid,
            conversations: this.conversations
          }
          const updated = await this.$store.dispatch('content/updateConversationHomework', payload)
          if (updated) {
            this.homework = _.cloneDeep(updated)
            if (updated.conversations && updated.conversations.length > 0) {
              this.conversations = updated.conversations.map((c, i) => ({
                ...c,
                _id: c._id || c.id || (this.conversations[i] ? this.conversations[i]._id : generateObjectId()),
                index: c.index || i + 1
              }))
            }
          } else {
            this.homework = _.cloneDeep(payload)
          }
        }
      } catch (err) {
        this.$message.error('Lỗi khi tự động lưu câu thoại')
      }
    },

    handleDeleteConversation(conv) {
      this.$confirm('Bạn có chắc chắn muốn xoá câu thoại này?', 'Cảnh báo', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(async () => {
        const targetId = conv._id || conv.id
        this.conversations = this.conversations.filter(s => {
          const sId = s._id || s.id
          return sId !== targetId
        })
        if (this.currentConversation) {
          const curId = this.currentConversation._id || this.currentConversation.id
          if (curId === targetId) {
            this.currentConversation = this.conversations.length > 0 ? this.conversations[0] : null
          }
        }
        await this.saveConversationsToBackend()
        this.$message.success('Đã xoá câu thoại')
      })
    },

    addLine(person) {
      if (person === 'A') {
        this.temp.A.push(['', '', '', ''])
      } else {
        this.temp.B.push(['', '', '', ''])
      }
    },
    removeLine(person, idx) {
      if (person === 'A') {
        this.temp.A.splice(idx, 1)
      } else {
        this.temp.B.splice(idx, 1)
      }
    },
    async saveConversation() {
      // Validate: Kiểm tra nhân vật đang nói phải có câu thoại (index 0 của dòng 0)
      const activeArr = this.temp.user === 'A' ? this.temp.A : this.temp.B
      if (!activeArr || !activeArr[0] || !activeArr[0][0]) {
        this.$message.error('Vui lòng nhập câu thoại cho nhân vật đang nói')
        return
      }

      if (!this.temp._id) {
        this.temp._id = generateObjectId()
      }

      if (this.conversationDialog.method === 'create') {
        this.conversations.push(_.cloneDeep(this.temp))
      } else {
        const targetId = this.temp._id
        const idx = this.conversations.findIndex(s => (s._id || s.id) === targetId)
        if (idx !== -1) {
          this.$set(this.conversations, idx, _.cloneDeep(this.temp))
          if (this.currentConversation && (this.currentConversation._id || this.currentConversation.id) === targetId) {
            this.currentConversation = this.conversations[idx]
          }
        }
      }
      this.conversationDialog.visible = false
      await this.saveConversationsToBackend()
      this.$message.success('Lưu câu thoại thành công')
    },
    handleUpdateHomework() {
      this.homeworkTemp = _.cloneDeep(this.homework)
      this.updateHomeworkDialog = true
    },
    async saveHomeworkSettings() {
      this.dialogLoading = true
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        if (targetId) {
          await examVaultApi.updateExam({
            _id: targetId,
            title: this.homeworkTemp.name,
            subject: this.homeworkTemp.subject
          })
          this.homework.name = this.homeworkTemp.name
          this.homework.title = this.homeworkTemp.name
        } else {
          const payload = {
            ...this.homeworkTemp,
            classId: this.classUid,
            conversations: this.conversations
          }
          await this.$store.dispatch('content/updateConversationHomework', payload)
          this.homework = _.cloneDeep(payload)
        }
        this.updateHomeworkDialog = false
        this.$message.success('Cập nhật thông tin bài tập thành công')
      } catch (err) {
        this.$message.error('Cập nhật thất bại')
      } finally {
        this.dialogLoading = false
      }
    },
    async handlePublishHomework() {
      this.loading = true
      try {
        const payload = {
          ...this.homework,
          classId: this.classUid,
          conversations: this.conversations,
          publish: !this.homework.publish
        }
        await this.$store.dispatch('content/publishConversationHomework', payload)
        this.homework.publish = !this.homework.publish
        this.$message.success('Thao tác thành công')
      } catch (err) {
        this.$message.error('Thao tác thất bại')
      } finally {
        this.loading = false
      }
    },
    handleCloneExamVault() {
      this.examVaultDialog.visible = true
    },
    async handleSelectExam(exam) {
      this.examVaultDialog.visible = false
      if (exam && exam.conversations && exam.conversations.length > 0) {
        const clonedConvs = _.cloneDeep(exam.conversations).map((c, i) => ({
          ...c,
          _id: c._id || c.id || generateObjectId(),
          index: this.conversations.length + i + 1
        }))
        this.conversations = [...this.conversations, ...clonedConvs]
        if (!this.currentConversation && this.conversations.length > 0) {
          this.currentConversation = this.conversations[0]
        }
        await this.saveConversationsToBackend()
        this.$message.success(`Đã lấy ${exam.conversations.length} câu thoại từ Kho học liệu`)
      } else {
        this.$message.warning('Kho học liệu này không có dữ liệu câu thoại')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vocabulary-homework {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  .left-hw-btn {
    display: flex;
    align-items: center;
  }
  .homework-title {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
  }
  .right-hw-btn {
    display: flex;
    align-items: center;
    .homework-edit {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 20px;
      color: #606266;
      transition: color 0.2s;
      &:hover {
        color: #1cab36;
      }
      .label {
        margin-left: 5px;
        font-weight: 500;
      }
    }
  }
}
.question-layout {
  margin-top: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  min-height: 550px;
}
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  .sidebar-title {
    font-weight: bold;
    font-size: 15px;
    color: #2c3e50;
    display: flex;
    align-items: center;
  }
}
.question-group-list {
  border-right: 1px solid #ebeef5;
  padding: 20px;
  .q-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 8px;
    border: 1px solid #f0f2f5;
    transition: all 0.2s ease;
    &:hover {
      border-color: #1cab36;
      background: #f6ffed;
    }
    &-selected {
      background: #e8f5e9;
      border-color: #1cab36;
      .title {
        color: #1cab36;
        font-weight: bold;
      }
    }
    .q-item-left {
      display: flex;
      align-items: center;
      gap: 10px;
      overflow: hidden;
      .conv-user-badge {
        font-size: 11px;
        font-weight: 800;
        padding: 2px 8px;
        border-radius: 4px;
        color: white;
        flex-shrink: 0;
        &.user-a {
          background: #1cab36;
        }
        &.user-b {
          background: #ff9800;
        }
      }
      .conv-info {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title {
          font-size: 13px;
          color: #303133;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sub-text {
          font-size: 11px;
          color: #909399;
        }
      }
    }
    .settings {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-shrink: 0;
      .action-btn {
        color: #909399;
        cursor: pointer;
        padding: 2px;
        border-radius: 4px;
        &:hover {
          color: #1cab36;
          background: #e8f5e9;
        }
        &.delete-btn:hover {
          color: #f56c6c;
          background: #fef0f0;
        }
      }
    }
  }
  .add-question-group-btn {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: center;
  }
}
.preview-section {
  padding: 24px;
}
.full-conversation-preview {
  .preview-header-bar {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 20px;
    .preview-title {
      font-size: 18px;
      font-weight: 700;
      color: #2c3e50;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .chat-viewport {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 12px;
    max-height: 520px;
    overflow-y: auto;
    border: 1px solid #e4e7ed;
    .chat-row {
      display: flex;
      margin-bottom: 20px;
      width: 100%;
      &.row-left {
        justify-content: flex-start;
      }
      &.row-right {
        justify-content: flex-end;
      }
      .avatar-circle {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        flex-shrink: 0;
        &.avatar-a {
          background: #1cab36;
          margin-right: 12px;
        }
        &.avatar-b {
          background: #ff9800;
          margin-left: 12px;
        }
      }
      .chat-bubble-container {
        max-width: 70%;
        .speaker-label {
          font-size: 11px;
          font-weight: 700;
          margin-bottom: 4px;
          &.label-a {
            color: #1cab36;
          }
          &.label-b {
            color: #ff9800;
            text-align: right;
          }
        }
        .chat-bubble {
          padding: 12px 16px;
          border-radius: 16px;
          margin-bottom: 8px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06);
          &.bubble-a {
            background: white;
            color: #303133;
            border: 1px solid #e4e7ed;
          }
          &.bubble-b {
            background: #1cab36;
            color: white;
            .bubble-mean {
              color: #e0f2f1;
            }
          }
          .bubble-text {
            font-size: 15px;
            font-weight: 600;
          }
          .bubble-mean {
            font-size: 13px;
            margin-top: 4px;
            color: #606266;
          }
          .bubble-audio {
            margin-top: 8px;
            .chat-audio-player {
              height: 32px;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.empty-state {
  text-align: center;
  padding: 80px 20px;
  p {
    color: #909399;
    margin-top: 12px;
    font-size: 15px;
  }
}
.custom-conv-dialog {
  .dialog-header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .dialog-title-text {
      font-size: 18px;
      font-weight: 700;
      color: #2c3e50;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .dialog-form-container {
    padding: 10px 0;
    .role-selector-bar {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-bottom: 16px;
      .selector-label {
        font-weight: 600;
        color: #606266;
        font-size: 14px;
      }
    }
    .order-input-bar {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-bottom: 24px;
      .selector-label {
        font-weight: 600;
        color: #606266;
        font-size: 14px;
      }
    }
    .role-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e4e7ed;
      &.role-card-a {
        border-top: 4px solid #1cab36;
      }
      &.role-card-b {
        border-top: 4px solid #ff9800;
      }
      .role-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        .role-title {
          font-size: 16px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 6px;
          &.title-a { color: #1cab36; }
          &.title-b { color: #ff9800; }
        }
      }
      .line-item-card {
        background: white;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 14px;
        margin-bottom: 12px;
        position: relative;
        .delete-line-btn {
          position: absolute;
          right: 8px;
          top: 8px;
          z-index: 2;
        }
      }
    }
  }
}
</style>
